export default {
    methods: {
        /**
         * Hacemos logout
         * @override
         */
        logout() {
            this.$authService
                .removeAuthData()
                .then(() => {
                    this.$store.dispatch('yuriMenuStore/reset');
                    this.$store.dispatch('formStore/deleteAllForms');
                })
                .finally(() => this.$router.replace(`/login`));
        }
    }
};
